module.exports = __webpack_public_path__ + "img/ikun.ef1ff191.png";